import React from 'react'
import withView from '../../cmn/docAutomation/withView';
import SarasTrans from '../../../library/notifications/SarasTrans';
import FormButton from '../../../library/form/components/FormActionButton2';
import FormROValue from '../../../library/form/components/FormROValue1';
import FormInput from '../../../library/form/components/FormInput';
import FormLabel from '../../../library/form/components/FormLabel'
import FormSH from '../../../library/form/components/FormSH';
import { UiView, UiViewContent, UiGridColOne, UiCol } from "../../../library/layout/Index";

const InvDetailRouteEditor = (props) => {
    const { formObject, viewData, closeModel } = props;

    const onSuccess = () => {
        if(closeModel)closeModel();
    }

    if (!viewData)
        return (null)

    return (
        <UiView>
            <UiViewContent style={{height:"415px"}}>
                <UiGridColOne>
                <UiCol>
                    <ul>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "customer" }} value="Customer" />
                            </span>
                            <FormInput formObject={formObject} rowKey="" className="uiInput"
                                action={{
                                    InputType: "ac", paramName: "customer", acMethod: "ProfileName", acDepCtrl: { dparam: '%dataList.valLDT', reqPerm: 1 }
                                }}
                            />
                            <FormSH formObject={formObject} rowKey="" action={{
                                actionId: "new", paramName: "customer",
                                actionName: "proComp", actionParam: {}, containerKey: "popup"
                            }} >
                            </FormSH>
                        </li>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "itemCode" }} value="Ticket Code" />
                            </span>
                            <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "itemCode" }} />
                        </li>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "itemCost" }} value="Item Cost" />
                            </span>
                            <FormInput formObject={formObject} rowKey="" className="uiInput"
                                action={{ InputType: "input", paramName: "itemCost", actionParam: { }  }}
                            />
                        </li>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "itemPrice" }} value="Sell Price" />
                            </span>
                            <FormInput formObject={formObject} rowKey="" className="uiInput"
                                action={{ InputType: "input", paramName: "itemPrice", actionId: "refresh", actionParam: { isPriceUpdated: 1 }  }}
                            />
                        </li>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "ccCash" }} value="Cash" />
                            </span>
                            <FormInput formObject={formObject} rowKey="" className="uiInput"
                                action={{ InputType: "input", paramName: "ccCash", actionId: "refresh", actionParam: { isCashCredit: 1, isCashUpdated: 1 } }}
                            />
                        </li>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "ccCredit" }} value="Credit" />
                            </span>
                            <FormInput formObject={formObject} rowKey="" className="uiInput"
                                action={{ InputType: "input", paramName: "ccCredit", actionId: "refresh", actionParam: { isCashCredit: 1,isCreditUpdated: 1 } }}
                            />
                        </li>
                    </ul>
                </UiCol>
                </UiGridColOne>
            </UiViewContent>
            <div className="phViewAction">
                    <div style={{ clear: "both" }}>
                        <div className="phAction" style={{ float: "right" }}>
                            <FormButton formObject={formObject} rowKey="" className="uiSaveAction uiSpacerH5"
                                action={{ actionId: "save",  actionParam: {}, onSuccess: onSuccess }}
                                text={<SarasTrans value="Save" />}>
                            </FormButton>
                            <FormButton formObject={formObject} rowKey="" className="uiCancelAction"
                                action={{ actionId: "cancel",  actionParam: {}, onSuccess: onSuccess }}
                                text={<SarasTrans value="Cancel" />}>
                            </FormButton>
                        </div>
                    </div>
                </div>
        </UiView>
    )
}

export default withView(InvDetailRouteEditor, "invRouteComp")